module.exports = __webpack_public_path__ + "static/media/Mt3logo.c66cf976.jpg";